(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/debounce-input/assets/javascripts/debounce-inputv2.js') >= 0) return;  svs.modules.push('/components/lb-ui/debounce-input/assets/javascripts/debounce-inputv2.js');

'use strict';

const _excluded = ["controlGroupClasName", "errorMessage", "hasError", "infoMessage"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _svs$ui$reactForm = svs.ui.reactForm,
  Input = _svs$ui$reactForm.Inputv2,
  ControlGroup = _svs$ui$reactForm.ControlGroup;
class DebounceInput extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      value: this.props.value
    });
    this.timer = null;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidUpdate(prevProps) {
    const value = this.props.value;
    if (prevProps.value !== value) {
      this.setValue(value);
    }
  }
  setValue(val) {
    this.setState({
      value: val
    });
  }
  handleInputChange(event) {
    event.persist();
    this.setState({
      value: event.target.value
    });
    if (this.timer) {
      clearTimeout(this.timer);
    }
    const _this$props = this.props,
      onChange = _this$props.onChange,
      debounceTime = _this$props.debounceTime;
    this.timer = setTimeout(() => {
      onChange(event);
    }, debounceTime);
  }

  handleKeyDown(event) {
    if (event.key === 'Enter' || event.keyCode === 13 || event.which === 13) {
      const onChange = this.props.onChange;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      onChange(event);
    }
  }
  render() {
    const value = this.state.value;
    const _this$props2 = this.props,
      controlGroupClasName = _this$props2.controlGroupClasName,
      errorMessage = _this$props2.errorMessage,
      hasError = _this$props2.hasError,
      infoMessage = _this$props2.infoMessage,
      rest = _objectWithoutProperties(_this$props2, _excluded);
    const inputProps = Object.keys(rest).filter(key => ['onChange', 'debounceTime'].indexOf(key) === -1).reduce((output, key) => _objectSpread(_objectSpread({}, output), {}, {
      [key]: rest[key]
    }), {});
    return React.createElement(ControlGroup, {
      className: controlGroupClasName !== null && controlGroupClasName !== void 0 ? controlGroupClasName : '',
      errorMessage: errorMessage,
      hasError: hasError,
      idForInput: "reactDebounceInputV2",
      infoMessage: infoMessage,
      v2: true
    }, React.createElement(Input, _extends({}, inputProps, hasError && {
      'aria-invalid': 'true'
    }, {
      "aria-describedby": "reactDebounceInputV2_desc",
      infomessage: infoMessage,
      onChange: this.handleInputChange,
      onKeyDown: this.handleKeyDown,
      value: value
    })));
  }
}
DebounceInput.defaultProps = {
  debounceTime: 250,
  hasError: false,
  value: ''
};
svs.lb_ui.debounceInput.DebounceInputV2 = DebounceInput;

 })(window);